import type { TFunction } from 'i18next';

export const tierLabel = (t: TFunction, productId: string, tierId: string) =>
  t([`${productId}.tiers.${tierId}.label`, `tiers.${tierId}.label`, tierId]);

export const perilLabel = (t: TFunction, productId: string, perilId: string) =>
  t([`${productId}.perils.${perilId}.label`, `perils.${perilId}.label`, perilId]);

export const perilOptionLabel = (
  t: TFunction,
  productId: string,
  perilId: string,
  option: string,
) => t([`${productId}.perils.${perilId}.options.${option}`, `options.${option}`, option]);
